export const environment = {
  environment: 'staging',
  storageKeys: {
    token: 'TOKEN',
    user: 'USER',
  },
  features: {
    symplMigration: true,
    discounts: true,
    agodaContentApi: true,
    agodaTestProperty: true,
    bdcContentApi: true,
    spreedlyWhitelist: {},
    airbnb: {
      bookingPreferences: true,
      bookingSettings: true,
      priceSettings: true,
      taxSettings: false,
    },
    losModality: true,
    signatureStandalone: true,
    compliance: true,
  },
  plans: {
    rategenieStandalone: 'rategenie_v3',
    signatureStandalone: 'signature_v3',
    tokeetStandalone: 'tokeet_v5',
    tokeetStandaloneYearly: 'tokeet_yr_v5',
  },
  prefix: 'tv3',
  cacheInterceptorLog: false,
  production: true,
  showSecurityDeposits: true,
  symplMaxRentals: 5,
  languages: [
    { name: 'English', value: 'en' },
    { name: 'German', value: 'de' },
    { name: 'Spanish', value: 'es' },
    { name: 'French', value: 'fr' },
    { name: 'Greek', value: 'el' },
    { name: 'Croatian', value: 'hr' },
    { name: 'Indonesian', value: 'id' },
    { name: 'Italian', value: 'it' },
    { name: 'Lithuanian', value: 'lt' },
    { name: 'Portuguese', value: 'pt' },
    { name: 'Serbian', value: 'sr' },
  ],
  defaultWhatsappSenderName: 'Tokeet Messaging Test',
  topDomain: '.dev.tokeetmail.com',
  apiUrl: 'https://stage.api.tokeet.com',
  signatureApiUrl: 'https://dev.api.usesignature.com',
  webreadyApiUrl: 'https://stage.api.usewebready.com',
  papiApiUrl: 'https://stage.papi.tokeet.com',
  sslAPIUrl: 'https://api.housesquatting.net',
  checklistUrl: 'https://stage.app.usechecklist.com/',
  rategenieApiUrl: 'https://dev.api.rategenie.io/v1',
  signatureUrl: 'https://stage2.app.usesignature.com/',
  automataUrl: 'https://stage.app.useautomata.com/',
  rategenieUrl: 'http://stage2.app.rategenie.io/',
  appStoreUrl: 'http://stage.store.tokeet.com/',
  reportsUrl: 'https://stage2.app.usemargins.com/',
  symplUrl: 'https://stage2.app.sympl.cm/',
  ownerCenterUrl: 'https://stage2.app.ownercenter.net/',
  webreadyUrl: 'https://stage.app.usewebready.com/',
  powerReportingUrl: 'https://stage.login.powerreporting.net',
  aiAPIUrl: 'https://dev.api.aireply.io',
  legacyTv3Url: 'https://stage.tv3.tokeet.com',
  perfume: true,
  config: {
    amplitudeApiKey: '29d4c2410e37e455be2b7e9655b4abcd',
    websiteDomains: ['.housesquatting.net'],
    bookingEngineDomains: ['.qeloa.com'],
    guestPortalDomains: ['.myrental.guide'],
    sentryDns: 'https://765b52100ae14668b2a4e595da6d043a@sentry.io/1402194',
    apiBaseUrl: 'https://stage.api.tokeet.com/',
    apiMailBaseUrl: 'https://stage.api.tokeet.com/web',
    CMBaseUrl: 'http://stage.cm.tokeet.com',
    invoiceBaseUrl: 'http://stage.invoices.advance.cm/',
    guestPortalUrl: 'http://stage.guest.tokeet.com/',
    registerUrl: 'http://register.tokeet.com/',
    helpUrl: 'http://helpdocs.tokeet.com/',
    oauthUrl: 'http://stage.oauth.tokeet.com',
    calendarShareUrl: 'https://stage.share.tokeet.com/calendar/',
    iCalEndpoint: 'https://stage.api.tokeet.com',
    googleMapKey: 'AIzaSyB1Y6gtva7YVwWejE4aEm3a7meDbq1GQlc',
    defaultSMSPhoneNumber: '+15592064364',
    mailChimpClientId: '977719245525',
    mailChimpRedirectUrl: 'http://dev.api.tokeet.com/oauth/mailchimp',
    mailChimpOAuthUrl: 'https://login.mailchimp.com/oauth2/authorize?response_type=code',

    slackClientId: '25867822561.8986401869686',
    stripe_publishable_key: 'pk_test_YnvnYwKFHkZ9gYhB15bzcGez',
    slackRedirectUrl: 'https://stage.api.tokeet.com/oauth/slack',
    slackOAuthUrl: 'https://slack.com/oauth/v2/authorize?response_type=code',

    dropboxClientId: 'pmc9hxua63dj1sf',
    dropboxRedirectUrl: 'https://dev.api.tokeet.com/oauth/dropbox',
    dropboxOAuthUrl: 'https://www.dropbox.com/oauth2/authorize?response_type=code',

    stripeClientId: 'ca_7WEyrb7ZtVcjeLzAgc6IAXN6jqfQyGYp',
    stripeRedirectUrl: 'https://stage.api.tokeet.com/oauth/stripe',
    stripeOAuthUrl: 'https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write',
    paypalUrl: 'https://www.sandbox.paypal.com',

    cloudinaryURL: 'https://api.cloudinary.com/v1_1',
    cloudinaryCloudName: 'tokeet',
    cloudinaryUploadPreset: 'isnhfkd5',

    topDomain: '.dev.tokeetmail.com',

    worldpayDeveloperId: '12345678',
    worldpayVersion: '1.0',

    dataFeedURL: 'http://dev.datafeed.tokeet.com',

    airbnbClientId: 'eqbd5krofbfq2skf11s2y8esm',
    airbnbRedirectUrl: 'https://stage.api.tokeet.com/oauth/abbv2/',
    airbnbOAuthUrl: 'https://www.airbnb.com/oauth2/auth?scope=vr,messages_read,messages_write&',

    intercomAppId: 'ziijopdr',
    wootricToken: 'NPS-a11df413',

    tokeetAIContractId: '788e45b6-78db-4970-af7f-da44ad5a8fe9',
    tokeetAIContractSignerRole: 'Contact',

    smartDevicesContractId: 'a1871b2e-5320-478c-b276-33981812dd22',
    smartDevicesContractSignerRole: 'Contact',
    seamPublishableKey: 'seam_pk1dYjXIT_6PP6Y77svUU7adoz2zWMPU/h',

    quickBooksClientId: 'AByzIzpEfYSkAzdK2svn5XfCQ3UgyxbLl765aHOiNccaDrTB4O',
    quickBooksRedirectUrl: 'https://stage.api.tokeet.com/quickbooks/oauth/callback',
    quickBooksOAuthUrl:
      'https://appcenter.intuit.com/connect/oauth2?scope=com.intuit.quickbooks.accounting openid profile email&response_type=code',
  },
}
